// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"src-components-Modal----modal-module---modalContainer---2w9tb","centerBlock":"src-components-Modal----modal-module---centerBlock---1n9on","modalCloseIcon":"src-components-Modal----modal-module---modalCloseIcon---3urag"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/modal.module.scss
// module id = 1148
// module chunks = 168707334958949